/** When your routing table is too long, you can split it into small modules **/

import Layout from '@/layout'

const electronicDisplay = {
  path: '/electronic-display',
  component: Layout,
  redirect: '/electronic-display/led',
  name: 'ElectronicDisplay',
  meta: {
    title: 'electronicDisplay',
    icon: 'screen',
    perm: 'cSiteLedManager'
  },
  children: [
    {
      path: 'led',
      component: () => import('@/views/electronic-display/led/index.vue'),
      name: 'Led',
      meta: {
        title: 'led',
        perm: 'cLedManager'
      }
    },
    {
      path: 'custom-screen',
      component: () => import('@/views/manage/custom-screen/index.vue'),
      name: 'CustomScreen',
      meta: { title: 'customScreen', perm: 'cCustomScreen' }
    }

  ]
}
export default electronicDisplay
